import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { useDrawer } from '../../drawer-context';
import { useThreekit } from '../../threekit-context';
import DrawerCategoryButtonGroup from '../drawer-category-button-group';
import HandleDrawerColors from './handle-dawer-colors';
import HandleDrawerLiner from './handle-drawer-liner';
import getDrawerCategories from '../util/getDrawerCategories';
import HandleDrawerBolster from './handle-drawer-bolster';
import HandleDrawerPivotRing from './handle-drawer-pivot-ring';

function HandleDrawer() {
  const { drawerCategory, drawerName, setDrawerCategory } = useDrawer();
  const { productTag, getHiddenCategories } = useThreekit();
  const allCategories = getDrawerCategories(productTag, drawerName);
  const hiddenCategories = getHiddenCategories();

  const drawerCategories = hiddenCategories.length
    ? allCategories.filter((category) => !hiddenCategories.includes(category))
    : allCategories;

  const foundDrawerCategory = drawerCategories.find(
    (category) => category === drawerCategory,
  );

  useEffect(() => {
    if (drawerName === 'Handle') {
      setDrawerCategory(foundDrawerCategory || drawerCategories[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerName, drawerCategory]);

  return (
    <div className="relative">
      <DrawerCategoryButtonGroup categories={drawerCategories} />
      {drawerCategory === 'Color & Material' && <HandleDrawerColors />}
      {drawerCategory === 'Liner' && <HandleDrawerLiner />}
      {drawerCategory === 'Bolster' && <HandleDrawerBolster />}
      {drawerCategory === 'Pivot Ring' && <HandleDrawerPivotRing />}
    </div>
  );
}

export default HandleDrawer;
